import Table from "./Table";
import { EmissionsSourceSummary } from "../api/models/EmissionsSource";

export type EmissionSourcesTableProps = {
    onRowClick: (id: number) => void;
    emissionSources: EmissionsSourceSummary[];
    orderBy?: string;
    onOrderBy: (orderBy: string) => void;
    sortOrder?: string;
};

const NotMaterialEmissionsSourcesTable = ({
    onRowClick,
    emissionSources,
    orderBy,
    sortOrder,
    onOrderBy,
}: EmissionSourcesTableProps) => {
    return (
        <Table
            className="!min-w-[1200px]"
            headings={[
                { label: "Unique Reference", orderByKey: "UniqueReference" },
                {
                    label: "Name",
                    orderByKey: "Name",
                },
                { label: "Location", orderByKey: "LocationName" },
                { label: "Category", orderByKey: "CategoryName" },
                { label: "Type", orderByKey: "TypeName" },
                { label: "Item", orderByKey: "ItemName" },
                { label: "Scope", orderByKey: "Scope" },
                { label: "Justification" },
            ]}
            data={emissionSources}
            renderRowCells={(rowData) => (
                <>
                    <td>{rowData.uniqueReference}</td>
                    <td>{rowData.name}</td>
                    <td>{rowData.locationName}</td>
                    <td>{rowData.categoryName}</td>
                    <td>{rowData.typeName}</td>
                    <td>{rowData.itemName}</td>
                    <td>{rowData.scope}</td>
                    <td>{rowData.justification}</td>
                </>
            )}
            onRowClick={(rowData) => onRowClick(rowData.id)}
            orderBy={orderBy}
            sortOrder={sortOrder}
            onOrderBy={onOrderBy}
        />
    );
};

export default NotMaterialEmissionsSourcesTable;
